import React from "react";

// 3D COMPONENT
import * as PANOLENS from "panolens";
import { Vector3 } from "three";

// COMPONENTS
import Snackbar from "@material-ui/core/Snackbar";

// STYLES
import { ModalWrapper, PadLockDigitWrapper, CryptLockWrapper, ClueWrapper, WelcomeWrapper } from "./Room.style";

import RoomImage from "Assets/Images/Civics/EscapeRoom/original_oval.jpg";
import PadLock from "Assets/Images/Civics/EscapeRoom/lock.png";
import CryptLock from "Assets/Images/Civics/EscapeRoom/lock2.png";
import KeyImage from "Assets/Images/Civics/EscapeRoom/key.png";
import CalendarImage from "Assets/Images/Civics/EscapeRoom/calendar.png";
import BookImage from "Assets/Images/Civics/EscapeRoom/book.png";
// import PresidentsImage from "Assets/Images/Civics/EscapeRoom/presidents.jpg";
import PresidentsImage from "Assets/Images/Civics/EscapeRoom/presidents1.png";
import NoteImage from "Assets/Images/Civics/EscapeRoom/Note.jpg";
import TransparentImage from "Assets/Images/Civics/EscapeRoom/transparent.png";
// import TransparentImage from "Assets/Images/Civics/EscapeRoom/clue1.png";
import Clue1 from "Assets/Images/Civics/EscapeRoom/clue1.png";
import Clue2 from "Assets/Images/Civics/EscapeRoom/clue2.jpg";
import { Button } from "@material-ui/core";
import CombinationLock from "./CryptLock/CryptLock";
import { DesignedBox } from "Components/Commons";
// import { InputBase, Tooltip } from "@material-ui/core";
// import CancelIcon from '@material-ui/icons/Cancel';
import { DesignWrapper } from "./Room.style";
import { Api, URL_CIVICS_DASHBOARD } from "Helpers";
import Questions from "./Questions/Questions";
import BackgroundMusic from "Assets/Sounds/Executive/Hail_To_the_Chief.mp3";
import { updateGameScore } from "Redux/Auth/Actions";
import { connect } from "react-redux";
import moment from "moment";
import withRouterWrapper from "Helpers/WithRouterWrapper";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { AnimatedButton } from "Components/Commons/Commons";
import CustomButton from "Components/Commons/CustomButton/CustomButton";

var viewer, panorama;

const CRYPT = "GEORGE";
const PAD_LOCK = "1789";

let initAxis = {
    x: null,
    y: null,
    z: null,
};

const TOOLS = {
    GAVEL: "GAVEL",
    HAND: "HAND",
};

const ACTIONS = {
    REMOVE: "REMOVE",
    ADD_TOOL: "ADD_TOOL",
    REMOVE_TOOL: "REMOVE_TOOL",
    MESSAGE: "MESSAGE",
    AFTER: "AFTER",
    PAD_LOCK: "PAD_LOCK",
    CRYPT_LOCK: "CRYPT_LOCK",
    DATA_MODAL: "DATA_MODAL",
    INFO_MODAL: "INFO_MODAL",
    KEY_FIND: "KEY_FIND",
    CLUE_FOUND: "CLUE_FOUND",
};

let interval;

// Image loading utility functions
const preloadImage = (src, retries = 3) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        let retryCount = 0;

        const attemptLoad = () => {
            img.onload = () => resolve(src);
            img.onerror = () => {
                retryCount++;
                if (retryCount < retries) {
                    console.warn(`Retrying image load (${retryCount}/${retries}):`, src);
                    setTimeout(attemptLoad, 1000 * retryCount); // Exponential backoff
                } else {
                    reject(new Error(`Failed to load image after ${retries} attempts: ${src}`));
                }
            };
            img.src = src;
        };

        attemptLoad();
    });
};

const checkWebGLSupport = () => {
    try {
        const canvas = document.createElement('canvas');
        return !!(window.WebGLRenderingContext &&
            (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
    } catch (e) {
        return false;
    }
};

const checkDeviceCapabilities = () => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isLowEndDevice = navigator.hardwareConcurrency <= 2 ||
        (navigator.deviceMemory && navigator.deviceMemory <= 2);

    return {
        isMobile,
        isLowEndDevice,
        hasWebGL: checkWebGLSupport()
    };
};

const welcomeFirstText = `Can you solve the clues to Escape the Oval Office?`
const welcomeSecondText = `When the very first leader took his stand, The nation placed its trust in his hand.`

// const [backgroundMusic, { stop: stopBackgroundMusic }] = useSound(BackgroundMusic, { volume: .2 });
class Room extends React.Component {
    constructor(props) {
        super(props);
        this.divRef = React.createRef();
        this.gameStatus = localStorage.getItem("gamesStatus") && JSON.parse(localStorage.getItem("gamesStatus"))
        this.panoramaClick = this.panoramaClick.bind(this);

        this.state = {
            currentPoint: initAxis,
            activeTool: TOOLS.HAND,
            availableTools: [TOOLS.HAND],
            snackBar: {
                open: false,
                message: "",
            },
            infoOpenedCount: Number(localStorage.getItem('demo_info_opened') || 0),
            infoSpots: infoSpots,
            padlockFind: false,
            padLockValue: "",
            cryptLockFind: false,
            cryptLockValue: "",
            isFindKey: false,
            dataModal: {
                visible: false,
                data: null,
            },
            infoModal: {
                visible: false,
                data: null,
            },
            clueModal: {
                visible: false,
                data: null,
            },
            welcomeModal: {
                visible: false,
                data: null,
            },
            showClues: true,
            clueId: 1,
            gameStatus: {},
            timer: 20,
            timerInterval: null,
            // New state for image loading
            imagesLoaded: false,
            loadingError: null,
            deviceCapabilities: checkDeviceCapabilities(),
            failedImages: [],
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({
                welcomeModal: {
                    visible: true,
                    data: welcomeFirstText,
                    title: true,
                },
            });
        }, 1000);

        if (Object.keys(this.gameStatus).length) {
            if (this.gameStatus?.isExecutiveActive) {
                this.preloadAllImages();
            } else setTimeout(() => this.props.router.navigate(URL_CIVICS_DASHBOARD));
        }
    }

    async preloadAllImages() {
        try {
            // Check device capabilities first
            //eslint-disable-next-line
            const { hasWebGL, isMobile, isLowEndDevice } = this.state.deviceCapabilities;

            if (!hasWebGL) {
                this.setState({
                    loadingError: "Your device doesn't support WebGL. Please try a different browser or device.",
                    imagesLoaded: false
                });
                return;
            }

            // Show loading state
            this.setState({ imagesLoaded: false, loadingError: null });

            // Log device information for debugging
            console.log('Device Capabilities:', {
                userAgent: navigator.userAgent,
                hardwareConcurrency: navigator.hardwareConcurrency,
                deviceMemory: navigator.deviceMemory,
                ...this.state.deviceCapabilities
            });

            // Preload all critical images
            const criticalImages = [
                RoomImage,
                PadLock,
                CryptLock,
                KeyImage,
                CalendarImage,
                BookImage,
                PresidentsImage,
                NoteImage,
                TransparentImage,
                Clue1,
                Clue2
            ];

            // For low-end devices, load images sequentially to avoid overwhelming
            if (isLowEndDevice) {
                console.log('Loading images sequentially for low-end device');
                const failedImages = [];
                for (const imageSrc of criticalImages) {
                    try {
                        await preloadImage(imageSrc);
                        console.log('Successfully loaded:', imageSrc);
                    } catch (error) {
                        console.error('Failed to load image:', imageSrc, error);
                        failedImages.push(imageSrc);
                        // Continue loading other images even if one fails
                    }
                }
                this.setState({ failedImages });
            } else {
                // For better devices, load images in parallel
                console.log('Loading images in parallel');
                const results = await Promise.allSettled(criticalImages.map(preloadImage));

                // Log results for debugging
                const failedImages = [];
                results.forEach((result, index) => {
                    if (result.status === 'fulfilled') {
                        console.log('Successfully loaded:', criticalImages[index]);
                    } else {
                        console.error('Failed to load:', criticalImages[index], result.reason);
                        failedImages.push(criticalImages[index]);
                    }
                });
                this.setState({ failedImages });
            }

            // If some images failed but not all, still allow the game to continue
            if (this.state.failedImages.length > 0 && this.state.failedImages.length < criticalImages.length) {
                console.warn('Some images failed to load, but continuing with available images');
            }

            this.setState({ imagesLoaded: true }, () => {
                this.getStatusOfGame();
                this.getGameScore();
            });

        } catch (error) {
            console.error('Image loading error:', error);
            this.setState({
                loadingError: "Failed to load some images. Please check your internet connection and refresh the page.",
                imagesLoaded: false
            });
        }
    }

    // Method to check image format compatibility
    checkImageFormatCompatibility(imageSrc) {
        const extension = imageSrc.split('.').pop().toLowerCase();
        const supportedFormats = ['jpg', 'jpeg', 'png', 'webp'];

        if (!supportedFormats.includes(extension)) {
            console.warn('Potentially unsupported image format:', extension, 'for image:', imageSrc);
        }

        return supportedFormats.includes(extension);
    }

    async componentWillUnmount() {
        if (interval) clearInterval(interval);
        const { location } = this.props.router;
        if (location && location?.state && location.state?.schoolClassTestId && location.state.schoolClassTestId.length) {
            const params = {
                studentId: this.props.profileInfo?.id,
                schoolClassTestId: location.state.schoolClassTestId,
            };
            const response = await new Api().get(`student/able-to-log-out`, { params });
            if (response.status === 200 || response.status === 201) {
                const data = response.data;
                if (data?.isAbleToLogOutFromEscapeRoom && data.isAbleToLogOutFromEscapeRoom) {
                    const dateTime = moment().format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
                    const payload = {
                        type: "LOGOUT",
                        studentId: this.props.profileInfo?.id,
                        schoolClassTestId: location.state.schoolClassTestId,
                        moduleName: "EXECUTIVE",
                        dateTime: dateTime,
                    };
                    new Api().post(`student/clock-in-clock-out`, { data: payload });
                }
            }
        }
    }

    setSpotsOfTheGame = () => {
        try {
            panorama = new PANOLENS.ImagePanorama(RoomImage);
            panorama.name = "Panorama";

            // Add error handling for panorama loading
            panorama.addEventListener('load', () => {
                console.log('Panorama loaded successfully');
            });

            panorama.addEventListener('error', (error) => {
                console.error('Panorama loading error:', error);
                this.setState({
                    loadingError: "Failed to load the room panorama. Please refresh the page.",
                    imagesLoaded: false
                });
            });

            this.attachPositionEvent();

            viewer = new PANOLENS.Viewer({
                container: this.divRef.current,
                autoHideInfospot: false,
                controlBar: false,
            });
            viewer.add(panorama);
            viewer.camera.position.set(100, 10, -10);

            // Add error handling for viewer
            viewer.addEventListener('error', (error) => {
                console.error('Viewer error:', error);
            });

            this.state.infoSpots.forEach((spot) => {
                this.addInfoSpot(spot);
            });

            panorama.addEventListener("click", this.panoramaClick);
        } catch (error) {
            console.error('Error setting up panorama:', error);
            this.setState({
                loadingError: "Failed to initialize the 3D viewer. Please refresh the page.",
                imagesLoaded: false
            });
        }
    };

    updateGame = () => {
        let newInfoSpots = [...this.state.infoSpots];
        let padLockSolved = newInfoSpots.findIndex((item) => item.image === PadLock);

        if (padLockSolved && this?.state?.gameStatus?.isPadlockComplete) {
            newInfoSpots.splice(padLockSolved, 1);
            this.setState(
                {
                    infoSpots: newInfoSpots,
                },
                () => {
                    this.setSpotsOfTheGame();
                    if (!this?.state?.gameStatus?.isCryptexComplete) return this.addCrypt();
                    this.addKeyOnTable();
                }
            );
            return;
        }

        this.setSpotsOfTheGame();
    };

    getStatusOfGame = async () => {
        // let response = await new Api().get("executive/escape-room/status");
        const data = {
            "escapeRoomScore": 0,
            "isEscapeRoomComplete": false,
            "clueId": 1,
            "escapeRoomQuestionScore": 0,
            "escapeRoomQuestionAttemptTime": 0,
            "escapeRoomPadlockScore": 0,
            "escapeRoomPadlockAttemptTime": 0,
            "isPadlockComplete": false,
            "escapeRoomCryptexScore": 0,
            "escapeRoomCryptexAttemptTime": 0,
            "isCryptexComplete": false
        }

        const response = { data }

        this.setState(
            {
                gameStatus: response.data,
                clueId: response?.data?.clueId,
                showClues: response?.data?.isPadlockComplete && response?.data?.clueId > 4 ? false : true,
            },
            () => this.updateGame()
        );
    };

    getGameScore = async () => {
        // const subjectId = this.props.subjects?.filter((item) => item.subject === "Civics")[0].subjectId;
        // let response = await new Api().get(`general/gameStatus?gameName=executive&subjectId=${subjectId}`);
        const data = {
            "currentScore": 0,
            "scoreDashBoardList": [
                {
                    "firstName": "mital9",
                    "lastName": "khimsuriya",
                    "profileImage": "https://openxcell-development-public.s3.ap-south-1.amazonaws.com/Civic_Master/Dummy/Avatar",
                    "totalScore": 180000,
                    "winnerPlace": 1
                },
            ]
        }
        const response = { data }
        this.props.updateGameScore(response.data.currentScore);
    };

    attachPositionEvent() {
        PANOLENS.Viewer.prototype.getPosition = function () {
            var intersects, point, panoramaWorldPosition, outputPosition;
            intersects = this.raycaster.intersectObject(panorama, true);

            if (intersects.length > 0) {
                point = intersects[0].point;
                panoramaWorldPosition = panorama.getWorldPosition();

                // Panorama is scaled -1 on X axis
                outputPosition = new Vector3(
                    -(point.x - panoramaWorldPosition.x).toFixed(2),
                    parseFloat(point.y - panoramaWorldPosition.y).toFixed(2),
                    parseFloat(point.z - panoramaWorldPosition.z).toFixed(2)
                );
            }

            return outputPosition;
        };
    }

    addInfoSpot(data) {
        try {
            let { position, text } = data;
            let el = document.getElementById("hover");

            // CSS OF THE HOVER PROPERTY
            el.textContent = text;
            el.style.color = "#fff";

            // infospot.addHoverText(text);

            if (data.changePosition) {
                var offset = new Vector3(viewer.camera.position.x + 10, viewer.camera.position.y + 10, viewer.camera.position.z - 30);
                viewer.camera.position.lerp(offset, 40);
            }

            // Create infospot with error handling
            let infospot;
            try {
                infospot = new PANOLENS.Infospot(data.scale, data.image, false);
            } catch (error) {
                console.error('Error creating infospot with image:', data.image, error);
                // Fallback to transparent image if the original fails
                infospot = new PANOLENS.Infospot(data.scale, TransparentImage, false);
            }

            infospot.position.set(position.x, position.y, position.z);
            infospot.addHoverElement(el, 40);
            panorama.add(infospot);
            infospot.setCursorHoverStyle("normal");

            // Add error handling for infospot
            infospot.addEventListener('error', (error) => {
                console.error('Infospot error:', error);
            });

            infospot.addEventListener("click", (e) => {
                if (data.active && data.active.tool === this.state.activeTool) {
                    // ===== NEW: demo-limit check for info/data infospots =====
                    const opensInfoModal = (data.active.actions || []).some(
                        (a) => a.type === ACTIONS.INFO_MODAL || a.type === ACTIONS.DATA_MODAL
                    );

                    // only count unique openings (mark the data object so we don't double-count)
                    if (opensInfoModal && !data._opened) {
                        const openedCount = this.state.infoOpenedCount || 0;

                        if (openedCount >= 3) {
                            // demo limit reached -> inform user and redirect to login
                            this.showMessage("Trial limit reached. Please login to continue.");
                            // small delay so message is visible before navigation
                            setTimeout(() => {
                                localStorage.removeItem('demo_info_opened');
                                this.props.router.navigate("/login");
                            }, 2000);
                            return; // prevent running the infospot actions
                        }

                        // mark this infospot as opened & increment counter
                        data._opened = true;
                        this.setState({ infoOpenedCount: openedCount + 1 });
                        localStorage.setItem('demo_info_opened', String(openedCount + 1));
                    }
                    // ===== end of new demo-limit logic =====

                    data.active.actions.forEach((action) => {
                        if (action.type === ACTIONS.REMOVE) infospot.dispose();
                        else if (action.type === ACTIONS.ADD_TOOL) this.addTool(action.tool);
                        else if (action.type === ACTIONS.REMOVE_TOOL) this.removeTool(action.tool);
                        else if (action.type === ACTIONS.MESSAGE) this.showMessage(action.message);
                        else if (action.type === ACTIONS.PAD_LOCK) this.setState({ padlockFind: true });
                        else if (action.type === ACTIONS.CRYPT_LOCK) this.setState({ cryptLockFind: true });
                        else if (action.type === ACTIONS.DATA_MODAL)
                            this.setState({
                                dataModal: {
                                    visible: true,
                                    data: data,
                                },
                            });
                        else if (action.type === ACTIONS.INFO_MODAL)
                            this.setState({
                                infoModal: {
                                    visible: true,
                                    data: data.infoText,
                                },
                            });
                        else if (action.type === ACTIONS.AFTER) {
                            this.addInfoSpot({
                                position: data.position,
                                text: data.text,
                                image: data.image,
                            });
                        } else if (action.type === ACTIONS.KEY_FIND) {
                            // this.showMessage("Congratulations you have escaped the oval office !!");
                            this.setState({ isFindKey: true });
                        }
                    });
                }
            });

            this.toggleInfospotVisibility();
        } catch (error) {
            console.error('Error adding infospot:', error);
            // Continue with other infospots even if one fails
        }
    }

    toggleInfospotVisibility() {
        setTimeout(() => {
            panorama.toggleInfospotVisibility(true);
        }, 0);
    }

    panoramaClick(e) {
        let axis = viewer.getPosition();
        let newDataModal = this.state.dataModal;
        let newInfoModal = this.state.infoModal;

        let state = {
            currentPoint: axis,
        };

        if (newDataModal.visible) newDataModal.visible = false;
        if (newInfoModal.visible) newInfoModal.visible = false;

        if (this.state.padlockFind) state.padlockFind = false;
        if (this.state.cryptLockFind) state.cryptLockFind = false;

        if (this.state.cryptLockFind && !this.state.cryptLockValue) {
            this.showMessage("Trial limit reached. Please login to continue.");
            // small delay so message is visible before navigation
            setTimeout(() => {
                this.props.router.navigate("/login");
            }, 1000);

            return
            // this.addCrypt();
        }

        if (this.state.padlockFind && !this.state.padLockValue) {
            this.showMessage("Trial limit reached. Please login to continue.");
            // small delay so message is visible before navigation
            setTimeout(() => {
                this.props.router.navigate("/login");
            }, 1000);
            // this.addPadLock()
            return
        };

        this.setState({ ...state, dataModal: newDataModal, infoModal: newInfoModal });
    }

    handleChangeClue = () => {
        let newClueModal = this.state.clueModal;
        let newClueId = this.state.clueId;

        if (newClueId < 4) {
            this.handleShowClues();
            this.setState({ showClues: true });
        } else if (newClueId === 4 && this?.state?.gameStatus?.isPadlockComplete && !this.state.gameStatus?.isCryptexComplete) {
            this.handleShowClues();
            this.setState({ showClues: true });
        } else {
            this.setState({ showClues: false });
        }

        newClueModal.visible = false;
        newClueModal.data = null;

        this.setState({ clueModal: newClueModal });
    };

    handleWelcomeModalClick = () => {
        const currentModalData = this.state.welcomeModal.data

        this.setState({
            welcomeModal: {
                visible: false,
                data: "",
            },
        });

        if (currentModalData === welcomeFirstText)
            setTimeout(() => {
                this.setState({
                    welcomeModal: {
                        visible: true,
                        data: welcomeSecondText,
                        title: true,
                    },
                });
            }, 1000);
    }

    handleShowClues = () => {
        interval = setInterval(() => {
            this.setState((prev) => {
                if (prev.timer > 0) {
                    return {
                        timer: prev.timer - 1,
                    };
                } else {
                    this.handleStartTimer();
                }
            });
        }, 1000);
        this.setState({ timerInterval: interval });
    };

    handleStartTimer = () => {
        clearInterval(interval);
        this.setState({ timer: 20 });
    };

    addPadLock = () => {
        this.addInfoSpot({
            text: "",
            position: { x: 3604.89, y: "-2007.34", z: "-2802.13" },
            // "position": { x: 3604.89, y: "-2007.34", z: "-2802.13" },
            scale: 400,
            image: PadLock,
            active: {
                tool: TOOLS.HAND,
                actions: [
                    {
                        type: ACTIONS.PAD_LOCK,
                    },
                    {
                        type: ACTIONS.REMOVE,
                    },
                ],
            },
        });
    };

    onFabClick() {
        this.addInfoSpot({ position: this.state.currentPoint, text: "Something" });
        this.setState({ currentPoint: initAxis });
    }

    addTool(tool) {
        let { availableTools } = this.state;
        availableTools.push(tool);
        this.setState({ availableTools });
    }
    removeTool(tool) {
        let { availableTools } = this.state;
        availableTools.splice(availableTools.indexOf(tool), 1);
        this.setState({ availableTools, activeTool: "" });
    }

    showMessage(message) {
        this.setState({
            infoModal: {
                visible: true,
                data: message,
                title: true,
            },
            // snackBar: {
            //     open: true,
            //     message
            // }
        });

        setTimeout(() => {
            this.setState({
                // snackBar: { open: false }
                infoModal: { visible: false },
            });
        }, 3000);
    }

    closeInput = async () => {
        if (this.state.padLockValue === PAD_LOCK) {
            this.addCrypt();
            this.showMessage("Congratulations you have found the key and you are one step closer to escaping the oval office !!");
            await new Api().put(`executive/escape-room/padlock-status?isPadlockComplete=true`);
            // this.getStatusOfGame();
            this.setState({ showClues: true, clueId: 4 });
            return;
        }

        this.addPadLock();
        this.showMessage("Oops no luck !!");
        await new Api().put(`executive/escape-room/padlock-status?isPadlockComplete=false`);
        // this.getStatusOfGame();
    };

    updatePadLockValue = (e) => {
        this.setState({ padLockValue: e.target.value });
    };

    padLockClick = (value) => {
        let { padLockValue } = this.state;
        padLockValue += value;

        this.setState({ padLockValue }, () => {
            if (padLockValue.length === 4) {
                setTimeout(() => {
                    this.closeInput(padLockValue);
                    this.setState({ padLockValue: "", padlockFind: false });
                }, 500);

                return;
            }
        });
    };

    addCrypt = () => {
        this.addInfoSpot({
            // position: { x: -294.16, y: "-1067.75", z: "4866.22" },
            // position: { x: -290.16, y: "-650.75", z: "1066.22" },
            position: { x: 246.21, y: "-2200.61", z: "4622.36" },
            image: CryptLock,
            changePosition: true,
            scale: 200,
            active: {
                tool: TOOLS.HAND,
                actions: [
                    {
                        type: ACTIONS.CRYPT_LOCK,
                    },
                    {
                        type: ACTIONS.REMOVE,
                    },
                ],
            },
        });
    };

    addKeyOnTable = () => {
        this.addInfoSpot({
            // position: { x: -410.02, y: "-1949.09", z: "4581.46" },
            position: { x: -360.02, y: "-1929.09", z: "4581.46" },
            image: KeyImage,
            // scale: 80,
            scale: 110,
            active: {
                tool: TOOLS.HAND,
                actions: [
                    {
                        type: ACTIONS.KEY_FIND,
                    },
                ],
            },
        });
    };

    updatedCryptValue = async (isCorrect, value = CRYPT) => {
        if (!isCorrect) {
            await new Api().put(`executive/escape-room/cryptex-status?isCryptexComplete=false`);
            return this.showMessage("Oops No luck !!!!!");
        }

        if (isCorrect) await new Api().put(`executive/escape-room/cryptex-status?isCryptexComplete=true`);
        this.setState({
            cryptLockValue: value,
            cryptLockFind: false,
        });

        this.addKeyOnTable();
        this.showMessage("Congratulations you have found the key and you are one step closer to escaping the oval office !!");
    };

    handleClue = async () => {
        let newClueId = this.state.clueId,
            data = "";


        switch (newClueId) {
            case 1:
                data = "On the calendar focus on the month";
                break;
            case 2:
                data = "Draw your eyes to the red page number in the book";
                break;
            case 3:
                data = "Cracking the code puzzler will provide you with the first three digits of the padlock";
                break;
            case 4:
                data = "Pay close attention to the first word on each line of the poem";
                break;
            default:
                break;
        }

        newClueId++;
        this.setState({ clueId: newClueId, clueModal: { visible: true, data: data }, showClues: false });
        await new Api().get("executive/escape-room/status", { params: { clueId: newClueId } });
    };

    handleSkipToLogin = () => {
        this.showMessage("Redirecting to the login page.");
        localStorage.removeItem('demo_info_opened');

        // small delay so message is visible before navigation
        setTimeout(() => {
            this.props.router.navigate("/login");
        }, 1000);
    }

    render() {
        const { imagesLoaded, loadingError, deviceCapabilities } = this.state;

        // Show loading screen
        if (!imagesLoaded && !loadingError) {
            return (
                <div style={{
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#f5f5f5'
                }}>
                    <CircularProgress size={60} />
                    <Typography variant="h6" style={{ marginTop: 20 }}>
                        Loading Escape Room...
                    </Typography>
                    <Typography variant="body2" style={{ marginTop: 10, color: '#666' }}>
                        Please wait while we load the 3D environment
                    </Typography>
                </div>
            );
        }

        // Show error screen
        if (loadingError) {
            return (
                <div style={{
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#f5f5f5',
                    padding: 20
                }}>
                    <Typography variant="h5" style={{ marginBottom: 20, color: '#d32f2f' }}>
                        ⚠️ Loading Error
                    </Typography>
                    <Typography variant="body1" style={{ marginBottom: 20, textAlign: 'center' }}>
                        {loadingError}
                    </Typography>
                    {!deviceCapabilities.hasWebGL && (
                        <Typography variant="body2" style={{ marginBottom: 20, color: '#666', textAlign: 'center' }}>
                            Device Capabilities: WebGL not supported
                        </Typography>
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => window.location.reload()}
                        style={{ marginTop: 10 }}
                    >
                        Refresh Page
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => this.props.router.navigate(URL_CIVICS_DASHBOARD)}
                        style={{ marginTop: 10 }}
                    >
                        Back to Dashboard
                    </Button>
                </div>
            );
        }

        return (
            <>
                <div style={{ display: "none" }}>
                    {" "}
                    <audio autoPlay loop={true} src={BackgroundMusic} controls />{" "}
                </div>

                <div ref={this.divRef} style={{ width: `calc(100vw - 0px)`, height: "calc(100vh - 0px)", overflow: "hidden" }}></div>

                <div id="hover" />

                {this.state.padlockFind && (
                    <PadLockDigitWrapper>
                        <div className="digit">
                            <span>{this.state.padLockValue}</span>
                        </div>
                        <div className="section">
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((item, index) => (
                                <Button className="card" key={index} onClick={() => this.padLockClick(item)}>
                                    {item}
                                </Button>
                            ))}
                        </div>
                    </PadLockDigitWrapper>
                )}

                {this.state.dataModal.visible && (
                    <ModalWrapper>
                        <div className="section">
                            <img
                                className="card"
                                src={this.state.dataModal.data.originalImage}
                                alt="data"
                                onError={(e) => {
                                    console.error('Modal image failed to load:', this.state.dataModal.data.originalImage);
                                    e.target.style.display = 'none';
                                }}
                            />
                        </div>
                    </ModalWrapper>
                )}

                {this.state.infoModal.visible && (
                    <DesignWrapper>
                        <DesignedBox center={this.state.infoModal.title}>
                            <div className="title-container">
                                <h1 className="title white-color"> {!this.state.infoModal.title ? "Did you know ?" : " "}</h1>
                            </div>

                            <div className="content-wrapper">
                                <div className="content" dangerouslySetInnerHTML={{ __html: this.state.infoModal.data }} />
                                {/* <Scrollbars
                                    className={"scroll-bar"}
                                    style={{ height: 100 }}
                                    // renderThumbVertical={ThumbVertical}
                                    autoHide
                                >
                                    
                                </Scrollbars> */}
                            </div>
                        </DesignedBox>
                    </DesignWrapper>
                )}

                {this.state.welcomeModal.visible && (
                    <WelcomeWrapper>
                        <DesignedBox center={this.state.welcomeModal.title}>
                            <div className="title-container">
                                <h1 className="title"> </h1>
                            </div>

                            <div className="content-wrapper">
                                <div className="content" dangerouslySetInnerHTML={{ __html: this.state.welcomeModal.data }} />
                            </div>
                        </DesignedBox>

                        <div className="button-wrapper full-width">
                            <AnimatedButton onClick={this.handleWelcomeModalClick}>{"Okay"}</AnimatedButton>
                        </div>
                    </WelcomeWrapper>
                )}

                {this.state.cryptLockFind && (
                    <CryptLockWrapper>
                        <CombinationLock updatedCryptValue={this.updatedCryptValue} />
                    </CryptLockWrapper>
                )}
                {this.state.clueModal.visible && (
                    <DesignWrapper>
                        <DesignedBox>
                            <div className="title-container">
                                <h1 className="title">Clues</h1>
                            </div>

                            <div className="content-wrapper">
                                <div className="clue-content" dangerouslySetInnerHTML={{ __html: this.state.clueModal.data || "" }} />
                            </div>
                        </DesignedBox>
                        <div className="button-wrapper full-width">
                            <AnimatedButton onClick={this.handleChangeClue}>{"Okay"}</AnimatedButton>
                        </div>
                    </DesignWrapper>
                )}
                <Snackbar
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    open={this.state.snackBar.open}
                    autoHideDuration={6000}
                    message={this.state.snackBar.message}
                />
                <ClueWrapper>
                    <div className="skip-to-login">
                        <Box position="relative" display="inline-flex">
                            <CustomButton onClick={this.handleSkipToLogin} text={"Skip to Login"} />
                        </Box>
                    </div>
                </ClueWrapper>

                {this.state.showClues && (
                    <ClueWrapper>
                        <div className="clue-image" onClick={this.state.timer > 19 && this.handleClue}>
                            {this.state.timer < 20 ? (
                                <Box position="relative" display="inline-flex">
                                    <CircularProgress variant="determinate" value={this.state.timer * 5} className="progress" thickness={1.8} />
                                    <Box top={0} left={0} bottom={0} right={0} position="absolute" display="flex" alignItems="center" justifyContent="center">
                                        <Typography variant="caption" component="div" color="textSecondary" className="timer">{`${this.state.timer}`}</Typography>
                                    </Box>
                                </Box>
                            ) : (
                                <div className="text">clue</div>
                            )}
                        </div>
                    </ClueWrapper>
                )}
                {this.state.isFindKey && <Questions open={this.state.isFindKey} handleClose={() => this.setState({ isFindKey: false })} gameStatus={this.state.gameStatus} />}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    counter: state.counter,
    subjects: state.Auth.subjectAccessList,
    role: state.Auth.role,
    profileInfo: state.Auth.profileInfo,
    schoolClassTestID: state.Auth.schoolClassTestID,
    gamesStatus: state.GamesData.gamesStatus,
});

const mapDispatchToProps = (dispatch) => {
    return {
        updateGameScore: () => {
            dispatch(updateGameScore());
        },
    };
};

export default withRouterWrapper(connect(mapStateToProps, mapDispatchToProps)(Room));

let infoSpots = [
    // INFORMATION
    {
        text: "",
        position: {
            x: 830.01,
            y: "115.47",
            z: "-4983.41",
            // x: 230.01,
            // y: "115.47",
            // z: "-4983.41"
        },
        scale: 1000,
        image: TransparentImage,
        infoText: "These will be the hidden facts about the Executive Branch that the user will need to pay attention to in order to pass the quiz at the end",
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.INFO_MODAL,
                },
            ],
        },
    },
    {
        text: "",
        position: {
            x: 1009.18,
            y: "-1410.31",
            z: "4685.17",
        },
        scale: 300,
        image: TransparentImage,
        infoText: "The President has the power to sign or veto legislation enacted by Congress",
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.INFO_MODAL,
                },
            ],
        },
    },
    {
        text: "",
        position: {
            x: -1946.21,
            y: "-1500.61",
            z: "4222.36",
            // x: -4518.39,
            // y: "-3592.24",
            // z: "10371.99"
        },
        scale: 400,
        image: TransparentImage,
        infoText: "The President can issue executive orders which has the force of law",
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.INFO_MODAL,
                },
            ],
        },
    },
    {
        text: "",
        position: {
            x: 2429.29,
            y: "-1675.93",
            z: "4027.18",
        },
        scale: 300,
        image: TransparentImage,
        infoText: "One of the jobs of the President is to enforce and implement the laws Congress has set in place",
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.INFO_MODAL,
                },
            ],
        },
    },
    {
        text: "",
        position: {
            x: -4846.12,
            y: "-1734.94",
            z: "1181.46",
            // x: -4846.12,
            // y: "-534.94",
            // z: "1081.46"
        },
        scale: 1500,
        image: TransparentImage,
        infoText: "The President is elected to 4 year terms and can only serve 2 terms",
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.INFO_MODAL,
                },
            ],
        },
    },
    {
        text: "",
        position: {
            x: 146.21,
            y: "-1884.61",
            z: "4622.36",
        },
        scale: 300,
        image: TransparentImage,
        infoText: "The requirements for becoming President are, you must be at least 35 years of age, a natural born citizen and have lived in the US for at least 14years",
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.INFO_MODAL,
                },
            ],
        },
    },
    {
        text: "",
        position: {
            x: 4820.33,
            y: "-1268.11",
            z: "249.28",
        },
        scale: 300,
        image: TransparentImage,
        infoText: "The President has the power to grant pardons to criminals who committed federal crimes",
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.INFO_MODAL,
                },
            ],
        },
    },
    {
        text: "",
        position: {
            x: 10001.95,
            y: "-579.79",
            z: 1000,
        },
        scale: 300,
        image: TransparentImage,
        infoText: "The President is responsible for promoting diplomacy with other nations and the signing of international treaties",
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.INFO_MODAL,
                },
            ],
        },
    },
    {
        text: "",
        position: {
            x: 4683.9,
            y: "-19.27",
            z: "1728.92",
        },
        scale: 300,
        image: TransparentImage,
        infoText: "The President is the leader of the US Government and is both the head of state and the Commander-in-Chief of the US Armed forces",
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.INFO_MODAL,
                },
            ],
        },
    },
    {
        text: "",
        position: {
            x: 4516.81,
            y: "-1269.45",
            z: "1701.02",
        },
        scale: 300,
        image: TransparentImage,
        infoText: "The Executive Branch, include the Vice President, the Executive Office of the President and the Cabinet",
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.INFO_MODAL,
                },
            ],
        },
    },
    {
        text: "",
        position: {
            x: -1657.12,
            y: "-1412.94",
            z: "4490.37",
        },
        scale: 300,
        image: TransparentImage,
        infoText: "The President is the leader of the executive branch",
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.INFO_MODAL,
                },
            ],
        },
    },
    // CLUES
    {
        text: "",
        position: { x: 3604.89, y: "-2007.34", z: "-2802.13" },
        scale: 400,
        image: PadLock,
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.PAD_LOCK,
                },
                {
                    type: ACTIONS.REMOVE,
                },
            ],
        },
    },
    {
        text: "",
        position: {
            x: -4830.64,
            y: "-250.90",
            z: "1081.74",
            // x: -4830.64,
            // y: "-112.90",
            // z: "1246.74"
        },
        scale: 1400,
        image: TransparentImage,
        originalImage: BookImage,
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.DATA_MODAL,
                },
            ],
        },
    },
    {
        text: "",
        position: {
            x: 884.59,
            y: "-5.56",
            z: "4915.06",
        },
        scale: 300,
        image: TransparentImage,
        originalImage: CalendarImage,
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.DATA_MODAL,
                },
            ],
        },
    },
    {
        text: "",
        position: {
            x: 4799.89,
            y: "-1381.27",
            z: "30.39",
        },
        scale: 300,
        image: TransparentImage,
        originalImage: NoteImage,
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.DATA_MODAL,
                },
            ],
        },
    },
    {
        text: "",
        position: {
            x: 746.21,
            y: "-2300.61",
            z: "4622.36",
        },
        scale: 300,
        image: TransparentImage,
        originalImage: Clue1,
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.DATA_MODAL,
                },
            ],
        },
    },
    {
        text: "",
        position: {
            x: 4516.81,
            y: "-200.45",
            z: "3101.02",
            // x: 10000.15,
            // y: "-1932.35",
            // z: "7000.43"
        },
        scale: 1300,
        image: TransparentImage,
        originalImage: Clue2,
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.DATA_MODAL,
                },
            ],
        },
    },
    {
        text: "",
        position: {
            x: -1769.95,
            y: "215.38",
            z: "4659.91",
        },
        scale: 500,
        image: TransparentImage,
        originalImage: PresidentsImage,
        active: {
            tool: TOOLS.HAND,
            actions: [
                {
                    type: ACTIONS.DATA_MODAL,
                },
            ],
        },
    },
];
